import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileNav } from './MobileNav';
import { ThemeToggle } from '@/components/ui/ThemeSelector';
import { PlayerBar } from '@/components/player/PlayerBar';
import { MiniPlayer } from '@/components/player/MiniPlayer';
import { FullPlayer } from '@/components/player/FullPlayer';
import { usePlayer } from '@/context/PlayerContext';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { isPlayerVisible } = usePlayer();

  return (
    <div className="min-h-screen bg-bg-base flex">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Mobile/Tablet Header */}
        <Header />

        {/* Desktop header bar (only shows theme toggle on desktop since nav is in sidebar) */}
        <div className="hidden lg:flex items-center justify-end px-6 py-3 border-b border-subtle">
          <ThemeToggle />
        </div>

        {/* Page content - extra padding when player is visible */}
        <main className={`flex-1 px-4 py-6 lg:px-8 pb-20 ${isPlayerVisible ? 'lg:pb-24' : 'lg:pb-6'}`}>
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileNav />

      {/* Global Player Components */}
      <PlayerBar />
      <MiniPlayer />
      <FullPlayer />
    </div>
  );
}

export { Sidebar } from './Sidebar';
export { Header } from './Header';
export { MobileNav } from './MobileNav';
